module.exports = __webpack_public_path__ + "img/cases-author-5.69034be.jpg";